import { render, staticRenderFns } from "./unsaved-changes-dialog.vue?vue&type=template&id=6ffcd3f2&scoped=true"
import script from "./unsaved-changes-dialog.vue?vue&type=script&lang=js"
export * from "./unsaved-changes-dialog.vue?vue&type=script&lang=js"
import style0 from "./unsaved-changes-dialog.vue?vue&type=style&index=0&id=6ffcd3f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffcd3f2",
  null
  
)

export default component.exports